import React, { useState } from "react";

export function Accordion(props) {
    function openAccordion(index) {
        props.setExpandIndexState(index);
    }
    let items = props.children ? props.children.map(function(child){
        return React.cloneElement(child, {
            activeIndexState: props.activeIndexState,
            openAccordion: openAccordion,
            visibleOnCollapse: props.visibleOnCollapse,
            stickyHeader: props.stickyHeader
        });
    }) : [];
    return (
        <div className='accordion'>
            {items}
        </div>
    );
}

export function AccordionItem({title, index, activeIndexState, children, visibleOnCollapse = false,
    openAccordion = null, alwaysVisibleOptionsNum = 0, numOfOptions = 0, showMore = false, stickyHeader = false, direction = 'row'}: {
        title?: string, index: number, activeIndexState?: number, children?: any, visibleOnCollapse?: boolean
        openAccordion?: any, alwaysVisibleOptionsNum?: number, numOfOptions?: number, showMore?: boolean, stickyHeader?: boolean, direction?: string}) {
    let remainingResults = numOfOptions - alwaysVisibleOptionsNum;
    return (
        <div className="accordion-item" id={'accordion-item-' + index}>
            <div className={'accordion-header ' + (stickyHeader && index === activeIndexState ? 'sticky ' :  '')}>
                <h3>{title}</h3>
                <div style={{display: showMore ? 'block': 'none'}}>
                    <div style={{display: index === activeIndexState && remainingResults > 0 ? 'block' : 'none'}} onClick={() => {openAccordion(-1)}}><button className='primary'>Show Less ▼</button></div>
                    <div style={{display: index === activeIndexState && remainingResults > 0 ? 'none' : 'block'}} onClick={() => {openAccordion(index)}}>
                        { remainingResults > 0 ? <button className='primary'>Show More <span>{'('+remainingResults+'+)'}</span></button> : '' }
                    </div>
                </div>
            </div>
            <div className={'content' + (index === activeIndexState || visibleOnCollapse ? '' : ' d-none') + ' direction-' + direction}>
                {children}
            </div>
        </div>
    );
}
